export const IMPERSONATION_SCOPE = {
    READ_ONLY: 'read_only',
    FULL_ACCESS: 'full_access',
} as const;

export const IMPERSONATION_DECISION = {
    APPROVE: 'approve',
    REJECT: 'reject',
} as const;

export type ImpersonationDecision = typeof IMPERSONATION_DECISION[keyof typeof IMPERSONATION_DECISION];

export const IMPERSONATION_TOKEN_TYPE = 'impersonation';

export const IMPERSONATION_STORAGE_KEYS = {
    AUTH_TOKEN: 'token',
    PENDING_PATH: 'auth.pendingPath',
    ORIGINAL_TOKEN: 'impersonation.originalToken',
    SESSION: 'impersonation.session',
} as const;

export const IMPERSONATION_API_ROUTES = {
    REQUESTS: '/auth/impersonation-requests',
    REVIEW: (token: string) => `/auth/impersonation-requests/review/${token}`,
    LOGIN_INFO: (token: string) => `/auth/impersonation-requests/review/${token}/login-info`,
    DECISION: (token: string, decision: ImpersonationDecision) =>
        `/auth/impersonation-requests/${token}/${decision}`,
    SESSIONS: '/auth/impersonation-sessions',
    CURRENT_SESSION: '/auth/impersonation-sessions/current',
} as const;

export const IMPERSONATION_APP_ROUTES = {
    HOME: '/',
    DASHBOARD: '/dashboards/general',
    MANAGEMENT: '/management/impersonation',
    REVIEW_PATTERN: '/impersonation/review/:token',
    START_PATTERN: '/impersonation/start/:token',
    REVIEW: (token: string) => `/impersonation/review/${token}`,
    START: (token: string) => `/impersonation/start/${token}`,
} as const;

export const IMPERSONATION_LIMITS = {
    REQUEST_REASON_MAX_LENGTH: 500,
    MILLISECONDS_PER_SECOND: 1000,
    MILLISECONDS_PER_MINUTE: 60_000,
    TIMER_INTERVAL_MS: 1000,
    TIMER_PAD_LENGTH: 2,
} as const;
